module.exports = __webpack_public_path__ + "img/crane.bc338f80.png";